import { render, staticRenderFns } from "./StravaLogin.vue?vue&type=template&id=72178714&"
import script from "./StravaLogin.vue?vue&type=script&lang=js&"
export * from "./StravaLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports